import { create } from "zustand"
import { persist } from "zustand/middleware"
import type { CouponDetail } from "./types"

type CouponState = {
  // Persisted
  appliedCodes: string[]
  // Transient — populated by useFetchCoupons on page load
  couponDetails: Record<string, CouponDetail>  // code → detail, covers user + auto coupons
  autoAppliedCodes: string[]
  isValidating: boolean
}

type CouponActions = {
  addCode: (code: string) => void
  removeCode: (code: string) => void
  clearCodes: () => void
  setCouponDetails: (details: Record<string, CouponDetail>) => void
  setAutoAppliedCodes: (codes: string[]) => void
  setIsValidating: (v: boolean) => void
}

export const useCouponStore = create<CouponState & CouponActions>()(
  persist(
    (set) => ({
      // State
      appliedCodes: [],
      couponDetails: {},
      autoAppliedCodes: [],
      isValidating: false,

      // Actions
      addCode: (code) =>
        set((s) => ({
          appliedCodes: s.appliedCodes.includes(code) ? s.appliedCodes : [...s.appliedCodes, code],
        })),

      removeCode: (code) =>
        set((s) => ({
          appliedCodes: s.appliedCodes.filter((c) => c !== code),
          couponDetails: Object.fromEntries(Object.entries(s.couponDetails).filter(([k]) => k !== code)),
        })),

      clearCodes: () => set({ appliedCodes: [], couponDetails: {}, autoAppliedCodes: [] }),

      setCouponDetails: (details) => set({ couponDetails: details }),

      setAutoAppliedCodes: (codes) => set({ autoAppliedCodes: codes }),

      setIsValidating: (v) => set({ isValidating: v }),
    }),
    {
      name: "calii-coupons",
      partialize: (s) => ({ appliedCodes: s.appliedCodes }),
    }
  )
)
